import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import listConfig, { KEYWORD_LIST_TYPE, MARKET_LIST_TYPE } from './listTypeConfig';
import Button from '../Buttons/Button';
import InputText from '../Inputs/InputText';

const defaultState = {
  listName: '',
  formOpened: false,
  listCreated: false,
};

const createCustomEvent = (eventName, data) => new CustomEvent(eventName, { detail: data });

class NewListForm extends PureComponent {
  static propTypes = {
    entities: PropTypes.array.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onSubmitCallback: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    listType: PropTypes.oneOf([MARKET_LIST_TYPE, KEYWORD_LIST_TYPE]).isRequired,
  }
  constructor() {
    super();
    this.state = {
      ...defaultState,
    };
    this.inputRef = React.createRef();
  }

  componentDidUpdate() {
    if (this.state.formOpened) {
      this.inputRef.current.focus();
    }
  }

  handleFormOpen = () => this.setState({ ...defaultState, formOpened: true });
  handleNameChange = value => this.setState({ listName: value });
  handleDelayedCloseMessage = () => {
    setTimeout(() => this.setState({ listCreated: false }), 3000);
  }

  handleFormSubmit = (e) => {
    e.preventDefault();
    const {
      entities, onSubmit, onSubmitCallback, loading, listType,
    } = this.props;
    const { listName } = this.state;
    if (loading || !listName) return;

    onSubmit();
    const params = listConfig[this.props.listType].prepareParameters(entities, { name: listName });
    listConfig[this.props.listType].createList(params)
      .then(({ data: { id } }) => {
        this.setState({ listCreated: true, formOpened: false }, () => {
          onSubmitCallback(listConfig[this.props.listType].createListCallbackParams(id, listName, entities));
          this.handleDelayedCloseMessage();
          document.dispatchEvent(createCustomEvent('new-list-added', { id, name: listName, listType }));
        });
      });
  }

  renderSuccessMessage = listName => (
    <div className="alert success market-success-message">
      <span className="mr-sm text-truncate">{listConfig[this.props.listType].listName} <strong>{listName}</strong> has been created</span>
    </div>
  );

  render() {
    const { formOpened, listName, listCreated } = this.state;
    return (
      <div className="new-market-form-container">
        {!formOpened &&
          <button className="btn btn-link text-blue text-16 p-l-0" type="button" onClick={this.handleFormOpen}>
            <i className="hicon-plus-circle-thin mr-xxs" />Create a new {listConfig[this.props.listType].listName}
          </button>
        }

        {listCreated && this.renderSuccessMessage(listName)}

        {formOpened && !listCreated &&
          <form className="new-market-form" onSubmit={this.handleFormSubmit}>
            <InputText
              value={listName}
              ref={this.inputRef}
              className="form-control"
              placeholder={`Name your new ${listConfig[this.props.listType].listName}`}
              onChange={this.handleNameChange}
            />
            <Button size="lg" disabled={!listName.length} type="submit">Add</Button>
          </form>
        }
      </div>
    );
  }
}

export default NewListForm;
